import * as types from './actionTypes';

export function setMenuOpenSection(sectionName) {
    return {
        type: types.SET_MENU_OPEN_SECTION,
        payload: sectionName,
    };
}

export function toggleMenuShown(currentState) {
    return {
        type: types.TOGGLE_MENU_SHOWN,
        payload: !currentState,
    };
}

export function toggleMobileMenuShown(currentState) {
    return {
        type: types.TOGGLE_MOBILE_MENU_SHOWN,
        payload: !currentState,
    };
}
